// Missing receipts: the Chase charges the coverage figure counts that have no
// receipt. The server sends them with the figure, from the same charges, so
// the list and the count cannot disagree. Under a person, a charge with no
// receipt on a shared account counts for each holder and is marked "shared
// account". Collapsed by default. Read only.
import { usd, shortDate } from './money';

/** The collapsed line: "2 charges with no receipt · $524.49", or null when coverage counted nothing. */
export function missingHeadline(cov) {
  if (!cov || !(cov.charges > 0)) return null;
  const n = (cov.missing || []).length;
  if (n === 0) return 'Every charge has a receipt';
  const unread = cov.missingWithoutAmount || 0;
  return `${n} charge${n === 1 ? '' : 's'} with no receipt · ${usd(cov.missingDollars)}${unread ? ` (${unread} amount${unread === 1 ? '' : 's'} not read)` : ''}`;
}

/** Charges no one holds a card for, under a person: "Monduras Coffee Co. ·9650 has no card on file: 1 charge, $12.00". */
export function notShownLines(cov) {
  return (cov?.notShown || []).map((n) => {
    const money = n.dollars !== null && n.dollars !== undefined ? `, ${usd(n.dollars)}${n.withoutAmount ? ` (${n.withoutAmount} not read)` : ''}` : ', amount not read';
    return `${n.account || 'An unknown account'} has no card on file: ${n.charges} charge${n.charges === 1 ? '' : 's'}${money}`;
  });
}

export default function MissingReceipts({ coverage: cov }) {
  const head = missingHeadline(cov);
  if (!head) return null;
  if (!cov.missing.length) return <p className="rc-note rc-missing-none">✓ {head}</p>;
  return (
    <details className="rc-missing">
      <summary>{head}</summary>
      <div className="rc-scroll">
        <table className="rc-table rc-missing-table">
          <thead><tr><th>Date</th><th>Merchant</th><th className="rc-missing-acct">Account</th><th className="num">Amount</th></tr></thead>
          <tbody>
            {cov.missing.map((m) => (
              <tr key={m.listItemId}>
                <td className="rc-nowrap">{shortDate(m.date) || '—'}</td>
                <td className="rc-missing-merchant">{m.merchant || 'Merchant not read'}{m.pending && <span className="rc-tag rc-tag--amber rc-missing-pending">Pending</span>}{m.sharedAccount && <span className="rc-tag rc-missing-pending" title="An account more than one person holds a card on: this charge counts for each of them">shared account</span>}<span className="rc-missing-acct2">{m.account || '—'}</span></td>
                <td className="rc-missing-acct">{m.account || '—'}</td>
                <td className="num">{m.amount !== null && m.amount !== undefined ? usd(m.amount) : <span className="rc-notax">not read</span>}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr><td colSpan={2}>Total</td><td className="rc-missing-acct" /><td className="num">{usd(cov.missingDollars)}</td></tr></tfoot>
        </table>
      </div>
      <p className="rc-note" style={{ marginBottom: 0 }}>With a receipt {usd(cov.chargeDollarsWithReceipt)} + no receipt {usd(cov.missingDollars)} = {usd(cov.chargeDollars)} on Chase. Read only: nothing here changes Finance or receipts.</p>
    </details>
  );
}
